import React, { useState } from "react";
import { FloatingHelpButton } from "../components/floating-help-button";
import { LearnMorePage } from "../components/learn-more-page";
import NewTestResults from "./NewTestResults";
import { FloatingResultMenu } from "../components/result-menu";

export default function ResultPage() {
  const [activeSection, setActiveSection] = useState("tests");
  const [selectedLevel, setSelectedLevel] = useState("B1");
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  const handleHelp = () => {
    setIsHelpOpen(true);
  };

  if (isHelpOpen) {
    return <LearnMorePage onBack={() => setIsHelpOpen(false)} />;
  }

  return (
    <div>
      <FloatingResultMenu
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        selectedLevel={selectedLevel}
        onLevelChange={(level) => setSelectedLevel(level)}
      />
      <FloatingHelpButton onClick={handleHelp} />
      <NewTestResults setSelectedLevel={setSelectedLevel} />
    </div>
  );
}
